const data = {
  Heating: {
    chart_data: {
      labels: [
        "Electricity",
        "Gas",
        "Wood",
        "Solar",
        "Heat Pump",
        "Fuel Oil",
        "Geothermal",
        "Other",
      ],
      datasets: [
        {
          data: [156, 116, 33, 5, 17, 5, 6, 9],
          backgroundColor: [
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
            "rgba(255, 206, 86, 0.6)",
            "rgba(75, 192, 192, 0.6)",
            "rgba(153, 102, 255, 0.6)",
            "rgba(255, 159, 64, 0.6)",
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
          ],
          borderWidth: 1,
        },
      ],
    },

    options: {
      responsive: true,
      maintainAspectRatio: true,
      cutoutPercentage: 50, // Adjust the size of the hole in the center (0 for a pie chart)
      legend: {
        display: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: "Are you aware of the estrogen pollution in tap water?",
        },
      },
    },
  },
  Issues: {
    chart_data: {
      labels: [
        "First position",
        "Second Position",
        "Third Position",
        "Fourth Position",
        "Fifth Position",
      ],
      datasets: [
        {
          categoryPercentage: 1,
          label: "Environmental impact",
          data: [25.80645161, 31.9, 20.79, 11.83, 9.68],
          backgroundColor: "rgb(255, 99, 132)",
        },
        {
          categoryPercentage: 1,
          label: "Cost",
          data: [46.95, 25.81, 16.85, 5.38, 4.66],
          backgroundColor: "rgb(75, 192, 192)",
        },
        {
          categoryPercentage: 1,
          label: "Usage",
          data: [2.15, 7.17, 11.47, 27.6, 51.61],
          backgroundColor: "rgb(53, 162, 235)",
        },
        {
          categoryPercentage: 1,
          label: "System maintenance",
          data: [5.02, 17.2, 33.33, 27.24, 16.85],
          backgroundColor: "rgb(53, 0, 235)",
        },
        {
          categoryPercentage: 1,
          label: "System maintenance",
          data: [
            20.07168459, 17.92114695, 17.56272401, 27.95698925, 17.20430108,
          ],
          backgroundColor: "rgb(53, 162, 100)",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        title: {
          display: true,
          text: "Chart.js Bar Chart - Stacked",
        },
      },
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
    },
  },
  NewHeating: {
    chart_data: {
      labels: [
        "First position",
        "Second Position",
        "Third Position",
        "Fourth Position",
      ],
      datasets: [
        {
          categoryPercentage: 1,
          label: "Environmental impact",
          data: [31.89964158, 22.9390681, 31.54121864, 13.62007168],
          backgroundColor: "rgb(255, 99, 132)",
        },
        {
          categoryPercentage: 1,
          label: "Cost",
          data: [40.86021505, 32.61648746, 18.99641577, 7.52688172],
          backgroundColor: "rgb(75, 192, 192)",
        },
        {
          categoryPercentage: 1,
          label: "System maintenance",
          data: [3.225806452, 7.52688172, 19.71326165, 68.45878136],
          backgroundColor: "rgb(53, 162, 235)",
        },
        {
          categoryPercentage: 1,
          label: "Efficiency",
          data: [23.65591398, 36.55913978, 29.390681, 10.03584229],
          backgroundColor: "rgb(53, 0, 235)",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        title: {
          display: true,
          text: "Chart.js Bar Chart - Stacked",
        },
      },
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
    },
  },
  Awareness: {
    chart_data: {
      labels: ["Yes", "No", "Maybe"],
      datasets: [
        {
          data: [173, 95, 11],
          backgroundColor: [
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
            "rgba(255, 206, 86, 0.6)",
          ],
          borderWidth: 1,
        },
      ],
    },

    options: {
      responsive: true,
      maintainAspectRatio: true,
      cutoutPercentage: 50, // Adjust the size of the hole in the center (0 for a pie chart)
      legend: {
        display: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: "Are you aware of the estrogen pollution in tap water?",
        },
      },
    },
  },

  CleanHeat: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      cutoutPercentage: 50, // Adjust the size of the hole in the center (0 for a pie chart)
      legend: {
        display: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: "",
        },
      },
    },
    chart_data: [
      {
        labels: ["Yes", "No", "Maybe"],
        datasets: [
          {
            data: [194, 3, 82],
            backgroundColor: [
              "rgba(255, 99, 132, 0.6)",
              "rgba(54, 162, 235, 0.6)",
              "rgba(255, 206, 86, 0.6)",
            ],
            borderWidth: 1,
          },
        ],
      },
      {
        labels: ["Yes", "No", "Maybe"],
        datasets: [
          {
            data: [36, 187, 56],
            backgroundColor: [
              "rgba(255, 99, 132, 0.6)",
              "rgba(54, 162, 235, 0.6)",
              "rgba(255, 206, 86, 0.6)",
            ],
            borderWidth: 1,
          },
        ],
      },
      {
        labels: ["Yes", "No", "Maybe"],
        datasets: [
          {
            data: [137, 13, 129],
            backgroundColor: [
              "rgba(255, 99, 132, 0.6)",
              "rgba(54, 162, 235, 0.6)",
              "rgba(255, 206, 86, 0.6)",
            ],
            borderWidth: 1,
          },
        ],
      },
    ],
  },
};

export default data;
